import {QueryHookOptions, gql, useQuery} from "@apollo/client";
import {SchedulingFlowState} from "./types";
import {API_CLIENT} from "@services/graphql/client";
import {api} from "@services/api";

export const SCHEDULING_FLOW_STATE_QUERY = gql`
  query SchedulingFlowStateQuery($visitorId: String) {
    schedulingFlowState(visitorId: $visitorId)
      @rest(
        type: "SchedulingFlowState"
        method: "GET"
        endpoint: "monolith"
        path: "/hib/visitors/{args.visitorId}/schedulingFlow"
      ) {
      isBooked
      flowId
      specialtyId
      apptReasonSlug
      locationSlug
      doctorId
      slotTime
      region
      patientInfo {
        email
        selectedPatientId
        firstName
        lastName
        dob
        phoneNumber
        phoneNumberCountry
        sexAtBirth
      }
    }
  }
`;

type Data = {
  schedulingFlowState: SchedulingFlowState;
};

type Variables = {
  visitorId: string;
};

export const useAbandonedBookingFlowStateQuery = ({
  context,
  ...options
}: QueryHookOptions<Data, Variables> = {}) =>
  useQuery<Data, Variables>(SCHEDULING_FLOW_STATE_QUERY, {
    context: {
      clientName: API_CLIENT,
      headers: api.getDefaultHeaders(undefined, undefined, true),
      ...context,
    },
    ...options,
  });
